// @ts-strict-ignore
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LMUrlUtilService } from '@app/services';
import { LMDialogButtonKey, LMUniqueIdService } from '@app/utils';
import { SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';
import { Subject } from 'rxjs/internal/Subject';
import { catchError, first } from 'rxjs/operators';
import { LMCreateReportSearchListDialogComponent } from './lm-create-report-search-list-dialog.component';

interface SearchListCriteria {
  listName?: {
    value?: string,
    filterType: string
  };
  titleName?: {
    value?: string,
    filterType: string
  }
  businessClass?: string;
  dataType?: string[];
}

@Injectable()
export class LMCreateReportSearchListDialogService {

  createReportUrl: string;
  reportType: LMReportType;

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private sohoModalDialogService: SohoModalDialogService,
    private http: HttpClient,
    private lmUrlUtilService: LMUrlUtilService,
  ) {

  }

  public getReportUrl(businessClass: string) {
    const baseUrl = this.lmUrlUtilService.getBaseUrl();
    const url = `${baseUrl}/report/${businessClass}`;
    return this.lmUrlUtilService.propagateSessionKeys(url, '?');
  }
}
